<div class="title_left">
  <h3>
    <ng-content></ng-content>
  </h3>
</div>
